import React, { Component } from 'react'
import { getWizardData } from '../../services/db'
import { handleRangePrimaryColor } from '../../services/colors/primary-colors'
import { handleRangeSecondaryColor } from '../../services/colors/secondary-colors'
import { handleRangeTertiaryColor } from '../../services/colors/tertiary-colors'

export class StepColorSliderHandle extends Component {
  state = {
    wizardPrimaryColors: null,
    colorsSecondary: null,
    colorsTertiary: null,
    primaryColorSelected: null,
    secondaryColorSelected: null,
    wizardData: null
  }

  componentDidMount() {

    const { match } = this.props    

    const wizardData = getWizardData(match)

    if (wizardData) { 
      wizardData.then( (data) => {

        this.setState({
          primaryColors: data.primaryColors,
          wizardPrimaryColors: data.colors
        })

        this.setPrimaryColor(null)

      }).catch((error) => {
        console.log('Error getting wizard data', error);
      })
      
    }

  }

  setPrimaryColor = async (ev) => {

    const primaryColorData = await handleRangePrimaryColor(ev, this.state, this.props)

    if (primaryColorData) {
      this.setState(primaryColorData)
      this.setSecondaryColor(null)
    }

  }

  setSecondaryColor = async (ev) => {

    const secondaryColorData = await handleRangeSecondaryColor(ev, this.state, this.props)

    if (secondaryColorData) {

      this.setState(secondaryColorData)
      this.setTertiaryColor(null)
    }
  }

  setTertiaryColor = async (ev) => {
    const tertiaryColorData = await handleRangeTertiaryColor(ev, this.state, this.props)
    

    if (tertiaryColorData) {
      this.setState(tertiaryColorData)
    }
  }


  render() {    
    return (
      <div>
        {this.props.children(this.state, this.props, this.setPrimaryColor, this.setSecondaryColor, this.setTertiaryColor)}
      </div>
    )
  }
}

export default StepColorSliderHandle
